import { render, staticRenderFns } from "./08-BigDataAnalysisCoursePlatform.md?vue&type=template&id=1028c3b0&"
import script from "./08-BigDataAnalysisCoursePlatform.md?vue&type=script&lang=js&"
export * from "./08-BigDataAnalysisCoursePlatform.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports